import * as React from "react";

const orderHistoryNew: React.FC = () => {
    return ( 
        <svg width="19" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M10.75 15h3v3h-3v-3ZM16 15h3v3h-3v-3Zm-5.25-5.25h3v3h-3v-3Zm5.25 0h3v3h-3v-3Zm3-4.5h-4.5v-3C14.5.975 13.525 0 12.25 0h-4.5C6.475 0 5.5.975 5.5 2.25v3H1c-.45 0-.75.3-.75.75v.15l1.425 9.075c.075.75.75 1.275 1.5 1.275H9.25V15H3.175L1.9 6.75H19v-1.5Zm-12-3c0-.45.3-.75.75-.75h4.5c.45 0 .75.3.75.75v3H7v-3Z" fill="#002554" fill-rule="evenodd"/></svg>
    );
};

export default React.memo(orderHistoryNew);
